import React,{useContext,useState} from 'react';
import {Button} from '@mui/material';
import axios from 'axios';
import {toast} from 'react-toastify';
import baseUrl from '../../../../BaseURL';
import {ContextData} from '../../../../context/Context';

export default function ResetUserPasswordButton({user}){
 const {Person,accesstoken}=useContext(ContextData);
 const [busy,setBusy]=useState(false);
 if(String(Person?.acc_level)!=='100')return null;
 async function reset(){
  if(busy)return;
  setBusy(true);
  try{
   const {data}=await axios.put(`${baseUrl}/auth/user-accounts/${encodeURIComponent(user.token)}/reset-password`,{},
    {withCredentials:true,headers:{authorization:`Bearer ${accesstoken}`},timeout:15000});
   toast.success(`${user.fname} ${user.lname}: ${data.message}`);
  }catch(error){toast.error(error.response?.data?.message||'The password could not be reset. Please try again.');}
  finally{setBusy(false);}
 }
 return <Button disabled={busy} onClick={reset} title="Reset password to 12345">{busy?'Resetting…':'Reset password'}</Button>;
}
